// extracted by mini-css-extract-plugin
export var container = "_3p-0";
export var icon = "_3p-1";
export var text = "_3p-2";